import moment from "moment";
import { QueryStringArgumentSerializer } from "./QueryStringArgumentSerializer";

const unspecifiedArgumentValue = 'unspecified';

export class DateArgumentSerializer
    extends QueryStringArgumentSerializer<Date | null> {
    constructor(
        key: string,
        onDeserializeCallback?: (value: Date | null) => void) {
        super(key, undefined, onDeserializeCallback);
    }

    dateFormat = 'YYYY-M-D';
    alternateDateFormats = ['YYYY-M-DD', 'YYYY-MM-D', 'YYYY-MM-DD'];

    parseDate = (value: string) => {
        const formats = [this.dateFormat, ...this.alternateDateFormats];
        let i = 0;

        do {
            const date = moment(value, formats[i], true);
            if (date.isValid()) {
                return date;
            }

        } while (++i < formats.length);

        return undefined;
    }

    serialize = (value: Date | undefined | null) => {
        if (value === null) {
            return unspecifiedArgumentValue
        }
        return value ? moment(value).format(this.dateFormat) : undefined
    };

    deserialize = (rawValue: string): void => {
        const value = rawValue ? decodeURIComponent(rawValue.trim()) : undefined;

        if (this.onDeserializeCallback) {
            if (value === unspecifiedArgumentValue) {
                this.onDeserializeCallback(null);
            } else {
                const date = value && this.parseDate(value);
                if (date && date.isValid()) {
                    this.onDeserializeCallback(date.startOf('day').toDate());
                }
            }
        }
    }
}
